<template>
  <v-row>
    <v-col>
      <div class="my-2 text-h6 text-center">Pesquisas por Dia Corrido</div>
      <v-data-iterator :no-data-text="noDataText" :items="items" :items-per-page.sync="itemsPerPage" :page="page"
        :search="searchTabela" :no-results-text="noResultsText" hide-default-footer>
        <template v-slot:header>
          <v-row justify="end">
            <v-col cols="4">
              <v-text-field v-model="searchTabela" clearable hide-details prepend-inner-icon="mdi-magnify"
                label="Busca" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:default="props">
          <v-data-table dense :headers="headers" :items="props.items" hide-default-footer class="elevation-1"
            disable-pagination>
            <!-- <template slot="item" slot-scope="data">
            <tr>
              <p v-for="(item, index) in Object.values(data.item)" :key="index">x</p>
              <p>y</p>
            </tr>
          </template> -->
          </v-data-table>
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center" justify="center">
            <div class="ml-4 mb-6 grey--text">
              <p>Total de Registros: {{ items.length }}</p>
            </div>
            <v-spacer />
            <div class="pb-9">
              <ListPagination :page="page" :numberOfPages="numberOfPages" @firstPage="firstPage()"
                @formerPage="formerPage()" @nextPage="nextPage()" @lastPage="lastPage()" />
            </div>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'

  import ListPagination from '@/componentes/ListPagination'

  export default {
    components: {
      ListPagination
    },
    props: {
      labels: Array,
      diasCorridos: Array,
      avaliacoesDiasCorridos: Array,
    },

    data: () => ({
      noDataText: process.env.VUE_APP_NO_DATA_TEXT,
      noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
      searchTabela: '',
      page: 1,
      itemsPerPage: 20,
      headers: [{
        text: 'Dia',
        value: 'data',
        align: 'left'
      }],
      items: [],
    }),

    computed: {
      numberOfPages() {
        return Math.ceil(this.items.length / this.itemsPerPage)
      },
    },

    methods: {
      nextPage() {
        if (this.page + 1 <= this.numberOfPages) {
          this.page += 1
        }
      },
      formerPage() {
        if (this.page - 1 >= 1) {
          this.page -= 1
        }
      },
      firstPage() {
        if (this.page > 1) {
          this.page = 1
        }
      },
      lastPage() {
        if (this.page < this.numberOfPages) {
          this.page = this.numberOfPages
        }
      },
      mapValues(obj) {

        let chavesDoObjeto = []
        let paresDoObjeto = []
        let valoresDoObjeto = []

        chavesDoObjeto = Object.keys(obj)
        paresDoObjeto = Object.entries(obj)

        chavesDoObjeto.sort(function (a, b) {
          let aux1 = ''
          let aux2 = ''

          aux1 = a.split(" - ")[0]
          aux2 = b.split(" - ")[0]

          return aux1 - aux2
        });

        for (let i in chavesDoObjeto) {
          for (let j in paresDoObjeto) {
            if (chavesDoObjeto[i] == paresDoObjeto[j][0]) {
              valoresDoObjeto.push(paresDoObjeto[j][1])
            }
          }
        }
        return valoresDoObjeto
      }
    },

    watch: {
      diasCorridos: {
        deep: true,
        immediate: true,
        handler() {
          this.diasCorridos.forEach((dia, index) => {
        
            if (typeof this.items[index] === 'undefined' || !this.items[index]) {
              this.items[index] = {}
            }
            this.items[index].data = moment(dia, 'D-M-YYYY').format('DD/MM/YYYY')
          })
        },
      },
      avaliacoesDiasCorridos: {
        deep: true,
        immediate: true,
        handler() {

          this.headers = [{
            text: 'Data',
            value: 'data',
            align: 'left'
          }]
          this.avaliacoesDiasCorridos.forEach((avaliacao, index) => {
            if (typeof this.items[index] === 'undefined' || !this.items[index]) {
              this.items[index] = {}
            }

            const valoresAvaliacao = this.mapValues(avaliacao)
           
            
            for (let i = 0; i < this.labels.length; i++) {
              // console.log(this.items, "items")
              // console.log(this.labels, "labels")
              if (this.labels[i] == 'Média' || this.labels[i] == 'Total') {
                this.items[index][`${this.labels[i]}`] = valoresAvaliacao[i]
              } else { 
                 this.items[index][`${this.labels[i]}`] = valoresAvaliacao[i].amount
              }

              if (this.headers.findIndex(header => header.value === this.labels[i]) === -1) {
                this.headers.push({
                  text: this.labels[i],
                  value: this.labels[i],
                  align: 'right'
                })
              }
            }
          })
        },
      },
    },
  }
</script>